export default __webpack_public_path__ + "static/media/img_03.0fa41495.jpg";